/**
 * This labels is used in totals component.
 */
export const TotalLabels = {
    retailPriceTitle: 'Enganche total:',
    installmentAmountTitle: 'Tu pago mensual será de:',
    mxn: 'MXN',
    button: 'Continúa',
    buttonAudiUsed: 'Preevalua aquí',
    tooltipModal: {
        title: 'Legales',
        defaultLegalTerms: `
        Para los cálculos a realizar en el preevaluador en línea se considera precio de lista del 
        modelo seleccionado (el precio de lista no incluye promociones/descuentos). Una vez concluida 
        tu preautorización, el concesionario te proporcionará la promoción/descuento vigente en caso 
        de que aplique.`,
    },
};
